import React, { Component } from 'react'

import Button from '../../components/Button/'
import Error from '../../components/Error/'
import { Cross } from '../Icons'
import { Container, Popup, CloseButton, ButtonContainer, Title, Header, Inner } from './styles'
import { white, almostblack, black, lightgray } from '../../styles/colors'

class DeletePopup extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.deleteUser({ variables: { data: { id: this.props.id } } })
  }

  render() {
    const { title, confirm, deny, error } = this.props
    if (error) {
      return <Error message={`Fout opgetreden bij het verwijderen van de gebruiker met ID: ${this.props.id}`} />
    }

    return (
      <Container>
        <Popup>
          <Inner>
            <Header>
              <Title>{title}</Title>

              <CloseButton onClick={this.props.closePopup}>
                <Cross size="xlarge" />
              </CloseButton>
            </Header>

            <ButtonContainer>
              <Button
                background={white}
                color={black}
                border={lightgray}
                radius="true"
                hover={almostblack}
                hoverColor={white}
                onSubmit={this.handleSubmit.bind(this)}
              >
                {confirm}
              </Button>

              <Button
                background={white}
                color={black}
                border={lightgray}
                radius="true"
                hover={almostblack}
                hoverColor={white}
                onSubmit={this.props.closePopup}
              >
                {deny}
              </Button>
            </ButtonContainer>
          </Inner>
        </Popup>
      </Container>
    )
  }
}

export default DeletePopup



// WEBPACK FOOTER //
// ./src/components/DeletePopup/index.js